var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"c-app"},[(_vm.first)?[_c('First')]:[_c('Sidebar'),_c('div',{staticClass:"c-wrapper"},[_c('Header'),_c('div',{staticClass:"c-body"},[_c('main',{staticClass:"c-main"},[_c('CContainer',{attrs:{"fluid":""}},[_c('transition',{attrs:{"name":"fade"}},[_c('router-view')],1)],1)],1)]),_c('CNotification'),_c('Footer')],1)]],2)
}
var staticRenderFns = []

export { render, staticRenderFns }